/**
 * Apparition au défilement.
 *
 * Les éléments à révéler ne sont pas marqués dans les gabarits : ils sont
 * désignés ici par une liste de sélecteurs. Un seul endroit à relire, et aucun
 * fichier Liquid à modifier pour ajuster l'effet.
 *
 * Chaque groupe est révélé avec un décalage entre voisins, ce qui donne le
 * mouvement d'ensemble sans que rien ne paraisse mécanique.
 *
 * Sont volontairement exclus les éléments qui ont déjà leur propre animation :
 * le hero et sa cascade, les points du distributeur, le bandeau défilant.
 */
(() => {
  const RACINE = document.documentElement;

  // Le mouvement est refusé : on ne masque rien, il n'y a rien à faire.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    RACINE.classList.remove('oyw-apparition');
    return;
  }

  /**
   * Groupes à révéler. « chiffre » emploie le glissement masqué, les autres
   * la montée en fondu. « pas » est le décalage entre voisins, en millisecondes.
   */
  const GROUPES = [
    { sel: '.oyw-commission__texte > *', pas: 90 },
    { sel: '.oyw-commission__chiffre', pas: 110 },
    { sel: '.oyw-commission__valeur', effet: 'chiffre', pas: 110 },

    { sel: '.oyw-hygiene__visuel', pas: 0 },
    { sel: '.oyw-hygiene__texte > *', pas: 90 },
    { sel: '.oyw-hygiene__valeur', effet: 'chiffre', pas: 110 },

    { sel: '.oyw-boissons__titre, .oyw-boissons__lien', pas: 90 },
    { sel: '.oyw-boissons__carte', pas: 90 },

    { sel: '.oyw-cta__texte > *', pas: 90 },
    { sel: '.oyw-cta__actions', pas: 0 },

    { sel: '.oyw-machine__titre', pas: 0 },

    { sel: '.oyw-page-hero__texte > *', pas: 90 },
    { sel: '.oyw-page-hero__visuel', pas: 0 },

    { sel: '.oyw-modele__entete > *', pas: 90 },
    { sel: '.oyw-modele__item', pas: 90 },

    { sel: '.oyw-etapes__titre', pas: 0 },
    { sel: '.oyw-etapes__choix', pas: 80 },
    { sel: '.oyw-etapes__panneaux', pas: 0 },

    { sel: '.oyw-sim__entete > *', pas: 90 },
    { sel: '.oyw-sim__reglages', pas: 0 },
    { sel: '.oyw-sim__resultats > *', pas: 100 },

    { sel: '.oyw-faq__titre', pas: 0 },
    { sel: '.oyw-faq__item', pas: 70 },
    { sel: '.oyw-faq__actions', pas: 0 },

    { sel: '.oyw-roles__titre', pas: 0 },
    { sel: '.oyw-roles__carte', pas: 120 },

    { sel: '.oyw-encart__texte > *', pas: 90 },
    { sel: '.oyw-encart__action', pas: 0 },

    { sel: '.oyw-legal__article', pas: 60 },

    { sel: '.oyw-footer__col', pas: 90 },
  ];

  /** Au-delà, le décalage se voit comme une attente plutôt qu'un enchaînement. */
  const RETARD_MAX = 420;

  const aRevelier = [];

  GROUPES.forEach(({ sel, effet, pas }) => {
    document.querySelectorAll(sel).forEach((el, rang) => {
      if (el.hasAttribute('data-oyw-apparition')) return;

      if (effet === 'chiffre') {
        // Le texte du chiffre est enveloppé : c'est lui qui glisse, le
        // conteneur se contentant de découper.
        const ligne = document.createElement('span');
        ligne.className = 'oyw-apparition__ligne';
        ligne.textContent = el.textContent.trim();
        el.replaceChildren(ligne);
        el.setAttribute('data-oyw-apparition', 'chiffre');
      } else {
        el.setAttribute('data-oyw-apparition', '');
      }

      el.style.setProperty('--oyw-apparition-retard', `${Math.min(rang * pas, RETARD_MAX)}ms`);
      aRevelier.push(el);
    });
  });

  if (aRevelier.length === 0) return;

  /**
   * La marge basse fait déclencher l'apparition un peu avant que l'élément ne
   * touche le bas de la fenêtre : il est déjà en place quand le regard y arrive.
   *
   * Le conteneur de défilement varie selon la largeur — au-dessus de 990px,
   * Horizon fait défiler .page-wrapper et non le document. On garde donc la
   * fenêtre comme référence, ce qui reste juste dans les deux cas.
   */
  const guetteur = new IntersectionObserver(
    (entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.setAttribute('data-vu', '');
        guetteur.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  aRevelier.forEach((el) => guetteur.observe(el));
})();
